import { useTranslation } from 'react-i18next';
import type { BillingForm } from '../store/billingSlice';
import type { Country } from '../types/country';
import { Billing } from './billing/Billing';

import styles from './checkoutLayout.module.scss';
import { Payment } from './payment/Payment';

export function BillingPaymentSection({
  total,
  form,
  fieldErrors,
  countries,
  submitLabel,
}: {
  total: number;
  form: BillingForm;
  fieldErrors: Record<string, string | null>;
  countries: Country[] | null;
  submitLabel?: string;
}) {
  const { t } = useTranslation();

  return (
    <section className={styles.step}>
      <h2 className={styles.stepTitle}>{t('Billing information')}</h2>
      <div className={styles.fieldsWrap}>
        <Billing form={form} fieldErrors={fieldErrors} countries={countries} />
        <Payment total={total} submitLabel={submitLabel} />
      </div>
    </section>
  );
}
